module.exports = __webpack_public_path__ + "static/EverForward7-928be671cef4d21e321c3935d9562fd7.webp";